
import { formatPrice } from '@/utils/bookingUtils';

interface PricingBreakdownProps {
  nights: number;
  price: number;
  cleaningFee: number;
}

const PricingBreakdown = ({ nights, price, cleaningFee }: PricingBreakdownProps) => {
  const subtotal = nights > 0 ? price * nights : 0;
  const totalPrice = subtotal + cleaningFee;

  return (
    <div className="mt-6 pt-6 border-t border-gray-200 space-y-3">
      <div className="flex justify-between items-center text-gray-600">
        <span>{nights} {nights === 1 ? 'noche' : 'noches'} × {formatPrice(price)}</span>
        <span>{formatPrice(subtotal)}</span>
      </div>
      <div className="flex justify-between items-center text-gray-600">
        <span>Tasa de limpieza</span>
        <span>{formatPrice(cleaningFee)}</span>
      </div>
      <div className="flex justify-between items-center font-semibold text-gray-900 pt-3 border-t border-gray-200">
        <span>Total</span>
        <span>{formatPrice(totalPrice)}</span>
      </div>
    </div>
  );
};

export default PricingBreakdown;
